import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component that handles scroll-to-top requests from native.
// When the user re-selects a tab in the native app, this callback
// is triggered to scroll the controller element to the top.
export default class extends BridgeComponent {
  static component = "scroll"

  connect() {
    super.connect()
    this.send("connect", {}, () => {
      this.element.scrollTo({ top: 0, behavior: "smooth" })
    })
  }
}
